module.exports = __webpack_public_path__ + "static/media/CICLO_3_PAZ_Y_COMUNIDAD_DIGITAL_2022.f3de15a8.jpg";